import dayjs from "dayjs";

export function formatTime (date?: Date|number|null): string {
    if(!date) {
        return '';
    }
    if(typeof date === 'number') {
        if(date < 9999999999) {
            date = date * 1000;
        }
        date = new Date(date);
    }
    const now = dayjs();
    const target = dayjs(date);
    if(!target.isValid()) {
        return '';
    }
    const diffSec = now.diff(target, 'second');
    const diffMin = now.diff(target, 'minute');
    const diffHour = now.diff(target, 'hour');

    if (diffSec <= 30) {
        return 'moment ago';
    } else if (diffSec <= 90) { // 1:30 min
        return 'minute ago';
    } else if (diffMin <= 7) {
        return '5 min ago';
    } else if (diffMin <= 30) {
        return '20 min ago';
    } else if (diffHour <= 1) {
        return 'hour ago';
    } else if (diffHour <= 24) {
        return "Today, " + target.format('HH:mm');
    } else {
        return target.format('YYYY-MM-DD HH:mm');
    }
}